
const benefits = [
  {
    icon: 'ri-flashlight-line',
    title: '今すぐ使える',
    description: '申し込んだその日からネットショッピングやスマホ決済で利用できます。急な出費や今日中に必要な買い物にも対応可能です。'
  },
  {
    icon: 'ri-smartphone-line',
    title: 'スマホで完結',
    description: '申し込みから審査、カード番号の確認まですべてスマホで完結。わざわざ店舗に行く必要がありません。'
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全性が高い',
    description: 'カード番号はアプリ内で安全に管理され、不正利用の心配も少なくなります。万が一の際も補償があるので安心です。'
  },
  {
    icon: 'ri-calendar-check-line',
    title: '待ち時間ゼロ',
    description: '従来のカードのように1〜2週間待つ必要がありません。最短10秒でカード番号が発行されるので、時間を無駄にしません。'
  },
  {
    icon: 'ri-shopping-cart-line',
    title: 'ネット通販に最適',
    description: 'Amazonや大手ECモールなどのネット通販ですぐに使えます。セールやタイムセールを逃さず買い物できます。'
  },
  {
    icon: 'ri-wallet-line',
    title: 'スマホ決済に登録可能',
    description: 'Apple PayやGoogle Payにすぐに登録できるので、コンビニやスーパーでもタッチ決済が使えます。'
  }
];

export default function Benefits() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">即日発行カードのメリット</h2>
        
        <div className="grid md:grid-cols-2 gap-6">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-gray-50 p-6 rounded-xl hover:shadow-lg transition-all duration-300">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className={`${benefit.icon} text-teal-600 text-2xl`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{benefit.title}</h3>
                  <p className="text-sm text-gray-700 leading-relaxed">{benefit.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-br from-teal-50 to-teal-100 border-2 border-teal-600 p-8 rounded-xl">
          <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
            <i className="ri-star-line text-teal-600"></i>
            こんな場面で即日発行カードが活躍
          </h3>
          <ul className="space-y-3">
            <li className="flex items-start gap-2 text-gray-700">
              <i className="ri-arrow-right-s-line text-teal-600 mt-1 flex-shrink-0"></i>
              <span><strong>急な出張や旅行：</strong>今日中にホテルや航空券を予約したい</span>
            </li>
            <li className="flex items-start gap-2 text-gray-700">
              <i className="ri-arrow-right-s-line text-teal-600 mt-1 flex-shrink-0"></i>
              <span><strong>セールやキャンペーン：</strong>期間限定のお得な買い物を逃したくない</span>
            </li>
            <li className="flex items-start gap-2 text-gray-700">
              <i className="ri-arrow-right-s-line text-teal-600 mt-1 flex-shrink-0"></i>
              <span><strong>サブスク登録：</strong>動画配信サービスやアプリの有料プランにすぐ登録したい</span>
            </li>
            <li className="flex items-start gap-2 text-gray-700">
              <i className="ri-arrow-right-s-line text-teal-600 mt-1 flex-shrink-0"></i>
              <span><strong>カード紛失時：</strong>メインカードを失くしてしまい、すぐに代わりが必要</span>
            </li>
          </ul>
        </div>

        {/* 中盤CTA：記事途中 */}
        <div className="mt-12 bg-white border-2 border-amber-400 rounded-2xl p-6 shadow-lg">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-2">
                <span className="bg-amber-100 text-amber-700 text-xs font-bold px-3 py-1 rounded-full">人気No.1</span>
                <span className="text-sm text-gray-600">即日発行カード</span>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">三井住友カード（NL）</h4>
              <p className="text-sm text-gray-600 mb-3">
                最短10秒でカード番号発行。年会費永年無料で、コンビニ・飲食店で最大7%還元。
              </p>
              <div className="flex flex-wrap gap-2">
                <span className="bg-teal-50 text-teal-700 text-xs px-2 py-1 rounded">最短10秒発行</span>
                <span className="bg-teal-50 text-teal-700 text-xs px-2 py-1 rounded">年会費無料</span>
                <span className="bg-teal-50 text-teal-700 text-xs px-2 py-1 rounded">最大7%還元</span>
              </div>
            </div>
            <div className="flex flex-col gap-2 w-full md:w-auto">
              <a
                href="/mitsui"
                className="bg-gradient-to-r from-teal-500 to-teal-600 text-white px-6 py-3 rounded-lg font-bold text-center hover:from-teal-600 hover:to-teal-700 transition-all duration-300 shadow-md whitespace-nowrap cursor-pointer"
              >
                詳細を見る
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
